export * from "./shared";   // rule 4: the folder always has all three files

/**
 * WEB half of `helper/myOrderHelpers`. Holds only what this platform can run alone.
 * `isAdvanceOrder` moved to `shared.ts` — it was one-sided by demand, not by capability.
 */
import store from "../../redux-store";
import { NW_APP_EVENT_ACTIONS, NW_APP_EVENT_KEYS } from "../../data/constants";
import { exec, isElectron } from "../../utils/nativeHooks";
import { stopSound } from "../../utils/notificationAudio";
import {
  notificationCurrentStatus,
  showStopNotificationNudge,
} from "../../redux-store/slices/NotificationsSlice";

/**
 * Silence the new-order alert and record that the operator stopped it.
 *
 * Two shells, two mechanisms: under Electron the ringer is this renderer's own `<audio>`, so it
 * is stopped in-process; under NW.js the sound belongs to the shell, so it is stopped by an IPC
 * `push/stop`. WEB-ONLY — the other platform has no desktop notification to stop.
 *
 * ⚠️ The two dispatches fire only when the notification was NOT already marked stopped, so
 * calling this twice does not re-hide the nudge. The apps' behaviour; preserved.
 */
export const stopDesktopNotification = () => {
  const notificationStatus = store.getState().notificationsStore?.isNotificationStop;
  if (isElectron()) {
    stopSound();
  } else {
    exec(NW_APP_EVENT_KEYS.push, NW_APP_EVENT_ACTIONS.push.stop, []);
  }
  if (!notificationStatus) {
    store.dispatch(notificationCurrentStatus(true));
    store.dispatch(showStopNotificationNudge(false));
  }
};
